import ListProduct from './ListProduct.jsx';

export {
  ListProduct
}


// WEBPACK FOOTER //
// ./components/my-business/list-product/index.js